import type { ReactNode } from 'react';

import { EUnavailableType } from '../../constants/unavailableType';

const conferenceEndedContent = (
    <>
        Встреча завершилась.
        <br />
        Если у&nbsp;вас остались вопросы,
        <br />
        вы&nbsp;можете задать их&nbsp;в&nbsp;чате Тренда.
    </>
);

const conferenceNotFoundContent = (
    <>
        Не&nbsp;нашли встречу.
        <br />
        Уточните актуальную ссылку
        <br />
        на&nbsp;встречу в&nbsp;чате Тренда.
    </>
);

const recordNotFoundContent = (
    <>
        Ищем запись. Попробуйте
        <br />
        вернуться через 20&nbsp;минут.
    </>
);

const recordUnavailableContent = (
    <>
        Техническая неполадки.
        <br />
        Попробуйте зайти позже или
        <br />
        обратитесь в&nbsp;поддержку
    </>
);

const restrictedAreaContent = (
    <>
        У&nbsp;вас нет доступа к&nbsp;записи.
        <br />
        Убедитесь, что вы&nbsp;зашли в&nbsp;систему
        <br />
        под рабочим аккаунтом.
    </>
);

export const unavailableContent: Record<EUnavailableType, ReactNode> = {
    [EUnavailableType.IS_OVER]: conferenceEndedContent,
    [EUnavailableType.NOT_FOUND]: conferenceNotFoundContent,
    [EUnavailableType.RECORD_NOT_FOUND]: recordNotFoundContent,
    [EUnavailableType.RECORD_UNAVAILABLE]: recordUnavailableContent,
    [EUnavailableType.RESTRICTED_AREA]: restrictedAreaContent,
};
